module.exports = __webpack_public_path__ + "img/km.786fe458.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/km.png
// module id = CIfK
// module chunks = 1